var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureRolesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.667 6.333V3c0-.368-.299-.667-.667-.667H6.412c-.252 0-.483-.143-.596-.368L5.184.702C5.071.476 4.84.333 4.588.333H1C.632.333.333.632.333 1v10c0 .368.299.667.667.667h4.667M10 12.333L7.667 12.333 7.667 14.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.278 13.155c-.564 1.653-2.202 2.69-3.937 2.492-1.734-.198-3.097-1.577-3.274-3.314M13.333 11L15.667 11 15.667 8.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.055 10.178c.564-1.652 2.202-2.69 3.937-2.492 1.735.198 3.097 1.577 3.275 3.314"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureRolesSmall);
export default __webpack_public_path__ + "static/media/azure-roles-small.985cbee5.svg";
export { ForwardRef as ReactComponent };